<template>
  <div>
    <v-data-table
      v-model="selectedRows"
      :headers="headers"
      :items="localApartmentList"
      :items-per-page="10"
      item-key="id"
      show-select
      class="elevation-1"
      :options="stateOptions"
      @update:options="onUpdate"
      :search="search"
      :custom-filter="customFilter"
      @click:row="onApartmentClick"
    >
      <template v-slot:top>
        <v-row
          class="mb-0"
          style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
        >
          <v-col class="d-flex align-center">
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="setStatusValue(editedItem.statusId)"
                  small
                  class="ml-4"
                  v-on="on"
                  >New Apartment</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form>
                    <v-container>
                      <v-row>
                        <v-text-field
                          v-model="editedItem.name"
                          label="Name"
                        ></v-text-field>
                      </v-row>
                      <v-row>
                        <v-select
                          :items="
                            $store.state.ApartmentTypeStore.apartmentTypes
                          "
                          v-model="editedItem.apartmentTypeId"
                          @change="handleApartmentTypeChange()"
                          label="Apartment Type"
                          item-text="name"
                          item-value="id"
                        ></v-select>
                      </v-row>
                      <v-row>
                        <v-select
                          :items="
                            $store.state.ApartmentOrientationStore
                              .apartmentOrientations
                          "
                          v-model="editedItem.apartmentOrientationId"
                          @change="handleApartmentOrientationChange()"
                          label="Apartment Orientation"
                          item-text="name"
                          item-value="id"
                        ></v-select>
                      </v-row>
                      <v-row>
                        <v-select
                          :items="getStatuses"
                          v-model="editedItem.statusId"
                          label="Status"
                          item-text="label"
                          item-value="value"
                          @change="setStatusValue(editedItem.statusId)"
                        ></v-select>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.floor"
                            label="Floor"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.area"
                            label="Area"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.rooms"
                            label="Rooms"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-if="isSuperAdmin">
                        <v-jsoneditor
                          v-model="editedItem.properties"
                          :plus="true"
                          height="300px"
                          :options="{ mode: 'text' }"
                        ></v-jsoneditor>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="copyDialog" max-width="400px">
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  class="ml-2"
                  :disabled="selectedRows.length === 0"
                  v-on="on"
                >
                  Copy ({{ selectedRows.length }})
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Copy apartments</span>
                </v-card-title>
                <v-card-text>
                  <p>
                    Copying {{ selectedRows.length }} apartment{{
                      selectedRows.length === 1 ? '' : 's'
                    }}. Each copy is named "&lt;name&gt; copy (n)" and does not
                    carry over the external id.
                  </p>
                  <v-text-field
                    ref="copyCountField"
                    v-model.number="copyCount"
                    type="number"
                    min="1"
                    label="Number of copies"
                    @keyup.enter="confirmCopy"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="copyDialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="confirmCopy"
                    >Copy</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              outlined=""
              label="Search"
              hide-details
              class="mr-4"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <tr>
          {{
            item.name
          }}
        </tr>
      </template>
      <template v-slot:item.apartmentTypeId="{ item }">
        <tr>
          {{
            getApartmentTypeName(item.apartmentTypeId)
          }}
        </tr>
      </template>
      <template v-slot:item.apartmentOrientationId="{ item }">
        <tr>
          {{
            getApartmentOrientationName(item.apartmentOrientationId)
          }}
        </tr>
      </template>
      <template v-if="showActions" v-slot:item.action="{ item }">
        <!-- <v-icon small class="mr-3" @click="editPois(item.id)"
          >mdi-alpha-p-circle-outline</v-icon
        > -->
        <v-icon size="18" class="mr-3" @click="onApartmentClick(item)"
          >edit</v-icon
        >
        <v-icon size="24" @click="deleteItem(item, $event)">close</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import VJsoneditor from 'v-jsoneditor/src/index'
import Enums from '@/helpers/Enums'
import { UserRolesMixin } from '@/mixins/UserRolesMixin'

export default {
  name: 'apartmentList',
  mixins: [UserRolesMixin],
  props: {
    apartmentList: {
      type: Array,
      required: true,
      default: function() {
        return {}
      }
    },
    showActions: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    VJsoneditor
  },
  data: function() {
    return {
      headers: [
        { text: 'APARTMENT', align: 'left', sortable: true, value: 'name' },
        {
          text: 'TYPE',
          align: 'left',
          sortable: true,
          value: 'apartmentTypeId'
        },
        {
          text: 'ORIENTATION',
          align: 'left',
          sortable: true,
          value: 'apartmentOrientationId'
        },

        { text: 'FLOOR', align: 'left', sortable: true, value: 'floor' },
        { text: 'ROOMS', align: 'left', sortable: true, value: 'rooms' },
        { text: 'AREA', align: 'left', sortable: true, value: 'area' },
        { text: 'STATUS', align: 'left', sortable: true, value: 'status' },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ],
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: 'New Apartment',
        buildingId: 0,
        apartmentTypeId: 0,
        apartmentOrientationId: 0,
        floor: 0,
        area: 0,
        rooms: 0,
        status: null,
        statusId: Enums.ApartmentStatus.apartment_status_available,
        properties: {}
      },
      defaultItem: {
        id: 0,
        name: 'New Apartment',
        buildingId: 0,
        apartmentTypeId: 0,
        apartmentOrientationId: 0,
        floor: 0,
        area: 0,
        rooms: 0,
        status: null,
        statusId: Enums.ApartmentStatus.apartment_status_available,
        properties: {}
      },
      selectedApartmentType: {},
      selectedApartmentOrientation: {},
      dialog: false,
      stateOptions: {},
      mounted: false,
      search: '',
      selectedRows: [],
      copyDialog: false,
      copyCount: 1
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Apartment' : 'Edit Apartment'
    },
    getStatuses() {
      let array = []
      for (const property in Enums.ApartmentStatus) {
        let obj = {
          label: this.$t(`apartmentStatuses.${property}`),
          value: Enums.ApartmentStatus[property]
        }
        array.push(obj)
      }
      return array
    },
    apartmentStatuses() {
      let statuses = []
      for (const property in Enums.ApartmentStatus) {
        statuses[Enums.ApartmentStatus[property]] = this.$t(
          `apartmentStatuses.${property}`
        )
      }
      return statuses
    },
    localApartmentList() {
      let self = this
      return this.apartmentList.map(a => {
        a.status = this.apartmentStatuses[a.statusId]
        return a
      })
    }

    // stateOptions: {
    // 	get: function() {
    // 		return localStorage.apartmentListOption
    // 			? JSON.parse(localStorage.apartmentListOptions)
    // 			: {};
    // 	},
    // 	set: function(value) {
    // 		localStorage.apartmentListOptions = JSON.stringify(value);
    // 	}
    // }
    // // apartmentList() {
    // //   return this.$store.state.BuildingStore.buildings;
    // // }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    copyDialog(val) {
      if (val) {
        this.copyCount = 1
        setTimeout(() => {
          if (this.$refs.copyCountField) this.$refs.copyCountField.focus()
        }, 200)
      }
    }
  },
  created: function() {
    //this.$store.dispatch("BuildingStore/fetchBuildings");
    this.stateOptions = localStorage.apartmentListOptions
      ? JSON.parse(localStorage.apartmentListOptions)
      : {}
  },
  mounted: function() {
    this.mounted = true
  },
  methods: {
    onApartmentClick(apartment) {
      this.$router.push(
        '/masterplans/' +
          this.$route.params.masterplanId +
          '/buildings/' +
          this.$route.params.buildingId +
          '/apartments/' +
          apartment.id
      )
    },

    onUpdate(value) {
      if (this.mounted) {
        localStorage.apartmentListOptions = JSON.stringify(value)
      }
    },
    customFilter(value, search, item) {
      //var exp = new RegExp(search, "i");
      return new RegExp(search, 'i').test(item.name)
      // search = search.toString().toLowerCase();
      // return items.filter(row => filter(row["name"], search));
    },
    getApartmentTypeName(apartmentTypeId) {
      let type = this.$store.state.ApartmentTypeStore.apartmentTypes.find(
        item => {
          return item.id === apartmentTypeId
        }
      )
      return type ? type.name : 'No type'
    },
    getApartmentOrientationName(apartmentOrientationId) {
      let type = this.$store.state.ApartmentOrientationStore.apartmentOrientations.find(
        item => {
          return item.id === apartmentOrientationId
        }
      )
      return type ? type.name : 'No type'
    },
    setStatusValue: function(id) {
      this.$store.dispatch('ApartmentStore/setApartmentValue', id)
    },
    handleApartmentTypeChange() {
      this.selectedApartmentType = this.$store.state.ApartmentTypeStore.apartmentTypes.find(
        item => {
          return item.id === this.editedItem.apartmentTypeId
        }
      )
      this.editedItem.apartmentTypeId = this.selectedApartmentType.id
      this.editedItem.area = this.selectedApartmentType.area
      this.editedItem.rooms = this.selectedApartmentType.rooms
    },
    handleApartmentOrientationChange() {
      this.selectedApartmentOrientation = this.$store.state.ApartmentOrientationStore.apartmentOrientations.find(
        item => {
          return item.id === this.editedItem.apartmentOrientationId
        }
      )
      this.editedItem.apartmentOrientationId = this.selectedApartmentOrientation.id
    },
    editPois(apartmentId) {
      this.$store
        .dispatch('ApartmentStore/setSelectedApartment', apartmentId)
        .then(
          this.$store
            .dispatch('PoiStore/setPoiContext', 'apartment')
            .then(res => {
              this.$router.push('/pois')
            })
        )
    },
    editItem(item, e) {
      e.stopPropagation()
      this.editedIndex = this.apartmentList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item, e) {
      e.stopPropagation()
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete apartment',
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Ok',
        ok: () => {
          this.deleteItemAction(item)
        },
        cancelText: 'Cancel'
      })
    },
    deleteItemAction(item) {
      const index = this.apartmentList.indexOf(item)
      this.$store
        .dispatch('ApartmentStore/deleteApartment', item.id)
        .then(res => {
          this.apartmentList.splice(index, 1)
        })
    },

    confirmCopy() {
      const copies = Math.max(1, Math.floor(Number(this.copyCount)) || 1)
      this.$store
        .dispatch('ApartmentStore/copyApartments', {
          apartments: this.selectedRows,
          copies
        })
        .then(() => {
          this.selectedRows = []
          this.copyDialog = false
        })
    },

    close() {
      this.dialog = false
      this.$store.dispatch('ApartmentStore/resetStatusValue')
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      this.editedItem.statusValue = this.$store.state.ApartmentStore.status
      if (this.editedIndex > -1) {
        //UPDATE
        //Object.assign(this.apartmentList[this.editedIndex], this.editedItem);
        this.$store
          .dispatch('ApartmentStore/updateApartment', this.editedItem)
          .then(res => {
            this.$store.dispatch('ApartmentStore/fetchApartments')
          })
      } else {
        //CREATE
        //this.apartmentList.push(this.editedItem);
        this.editedItem.buildingId = this.$store.state.BuildingStore.selectedBuilding.id
        this.$store
          .dispatch('ApartmentStore/addApartment', this.editedItem)
          .then(res => {
            this.$store.dispatch('ApartmentStore/fetchApartments')
          })
      }
      this.close()
    }
  }
}
</script>

<style scoped></style>
